module.exports = __webpack_public_path__ + "3495400809e9c9f1504406983da7b51f.pdf";